module.exports = __webpack_public_path__ + "static/media/portuguese_flag.8ce156e0.svg";